<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12">
      <p-panel header="{{ 'SARLAFT.LBL_DATOSGENERALES' | translate }}">
        <fieldset>
          <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fNiveles" name="fNiveles">
            <div class="grid form-group">
              <div class="col-12 md:col-6 lg:col-6">
                <div class="div-form">
                  <label>* {{ 'SARLAFT.LBL_CODIGO' | translate }}</label>
                  <input type="text" pInputText id="codigo"
                         name="codigo"
                         autocomplete="off"
                         formControlName="codigo"
                         maxlength="6"
                         (blur)="!nivel ? verificarCodigo() : null"
                         codigos-reactive
                         [readonly]="!!nivel"
                  >
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.codigo.invalid">
                    {{ 'SARLAFT.LBL_CODIGO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="codExiste">
                    {{ 'SARLAFT.MSG_CODIGOEXISTE' | translate}}
                  </div>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-6">
                <div class="div-form">
                  <label>* {{ 'SARLAFT.LBL_NIVELDERIESGO' | translate }}</label>
                  <input type="text" pInputText id="nombre"
                         name="nombre"
                         autocomplete="off"
                         formControlName="nombre"
                         maxlength="10"
                         capitalize-reactive
                  >
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.nombre.invalid">
                    {{ 'SARLAFT.LBL_NIVELDERIESGO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>
            </div>
            <div class="grid form-group">
              <div class="col-12 md:col-6 lg:col-6">
                <div class="div-form">
                  <label>* {{ 'SARLAFT.LBL_RANGOMINIMO' | translate }}</label>
                  <input type="text"
                        pInputText
                        id="rangoMinimo"
                        name="rangoMinimo"
                        autocomplete="off"
                        formControlName="rangoMinimo"
                        appTexto
                        maxlength="4"
                        numero-entero-reactive
                        [sinComa]="true"
                        [sinEspacio]="true"
                        [sinCaracteres]="true"
                        [sinPunto]="true"
                        [sinLetras]="true"
                        (blur)="validarValorMaximo(); verificarTipo()"
                  >
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.rangoMinimo.invalid">
                    {{ 'SARLAFT.LBL_RANGOMINIMO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-6">
                <div class="div-form">
                  <label>* {{ 'SARLAFT.LBL_RANGOMAXIMO' | translate }}</label>
                  <input type="text"
                          pInputText
                          id="rangoMaximo"
                          name="rangoMaximo"
                          autocomplete="off"
                          formControlName="rangoMaximo"
                          appTexto
                          maxlength="4"
                          numero-entero-reactive
                          [sinComa]="true"
                          [sinEspacio]="true"
                          [sinCaracteres]="true"
                          [sinPunto]="true"
                          [sinLetras]="true"
                          (blur)="validarValorMaximo()"
                  >
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.rangoMaximo.invalid">
                    {{ 'SARLAFT.LBL_RANGOMAXIMO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="!validarMaximo">
                    {{ 'SARLAFT.MSG_RANGOMAXIMO' | translate}}
                  </div>
                </div>
              </div>
            </div>
            <div class="grid form-group" *ngIf=" lisTipoProcesosCreditos.length > 0 ">
              <div class="col-12 md:col-6 lg:col-6">
                <div class="div-form">
                  <label>* {{ 'SARLAFT.LBL_TIPODEPROCESO' | translate }}</label>
                  <p-dropdown disableTab  id="idTipoProcesoCredito" name="idTipoProcesoCredito" [options]="lisTipoProcesosCreditos"
                              placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                               formControlName="idTipoProcesoCredito"
                              (onChange)="verificarCodigo(false); verificarTipo()"
                              emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                              emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                              optionValue="value"
                              optionLabel="label"
                  ></p-dropdown>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idTipoProcesoCredito.invalid">
                    {{ 'SARLAFT.LBL_TIPODEPROCESO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>
            </div>
            <div class="grid form-group">
              <div class="col-12 md:col-12 lg:col-12">
                <div class="div-form">
                  <label style="font-size:14px">* {{ 'SARLAFT.LBL_DESCRIPCION' | translate }}</label>
                  <textarea pInputTextarea rows="4" id="descripcion" name="descripcion"  [maxlength]="200"
                            formControlName="descripcion"style="resize: none;"
                  ></textarea>

                  <label class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.descripcion.errors?.required">
                    {{ 'El Campo :' | translate }} "{{ 'SARLAFT.LBL_DESCRIPCION' | translate}}" {{ 'LBL_REQUERIDO' | translate}}
                  </label>
                </div>
              </div>
            </div>

            <div class="grid form-group">
              <div class="col-12 md:col-12 lg:col-12" style="font-size: 8.5px;">
                <h6 class="titulo-pagina" style="padding-bottom:10px">{{ 'SARLAFT.LBL_DECISIONPROCESO' | translate}}</h6>
              </div>
            </div>

            <div class="grid">
              <div class="col-12 lg:col-4 md:col-4" *ngFor="let tipoDecisiones of listasDecisionesSarlaft; let i = index">
                <p-radioButton  name="idDecisionProcesoSarlaft" label="{{ tipoDecisiones.nombre }}"
                                formControlName="idDecisionProcesoSarlaft"
                                [value]="tipoDecisiones.idLista" (onClick)="validarTipoDecision()"></p-radioButton>
              </div>
            </div>

            <div class="grid form-group" *ngIf="mostrarCampoInput && lisEstadosNovedades.length > 0 && lisCausalesSolicitudes.length > 0 ">
              <div class="col-12 md:col-6 lg:col-6">
                <div class="div-form">
                  <label>* {{ 'SARLAFT.LBL_ESTADO' | translate }}</label>
                  <p-dropdown disableTab  id="idEstado" name="idEstado" [options]="lisEstadosNovedades"
                              placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                               formControlName="idEstado"
                              emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                              emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                              optionValue="value"
                              optionLabel="label"
                  ></p-dropdown>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idEstado.invalid">
                    {{ 'SARLAFT.LBL_ESTADO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>
              <div class="col-12 md:col-6 lg:col-6">
                <div class="div-form">
                  <label>* {{ 'SARLAFT.LBL_CAUSAL' | translate }}</label>
                  <p-dropdown disableTab  id="idCausal" name="idCausal" [options]="lisCausalesSolicitudes"
                              placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                               formControlName="idCausal"
                              emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                              emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                              optionValue="value"
                              optionLabel="label"
                  ></p-dropdown>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idCausal.invalid">
                    {{ 'SARLAFT.LBL_CAUSAL' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>
            </div>


            <div class="grid form-footer-buttons">
              <div class="form-group col-12">
                <div *ngIf="!guardando">
                  <a (click)="regresar(formulario.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
                  <button *ngIf="!nivel"
                          icon="fa fa-plus" label="{{'BTN_AGREGAR' | translate }}"
                          type="submit"
                          pButton></button>
                  <button *ngIf="nivel"
                          icon="fa fa-floppy-o" label="{{'BTN_GUARDAR' | translate }}"
                          type="submit"
                          pButton></button>
                </div>
                <div *ngIf="guardando">
                  <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                  <span>{{'LBL_GUARDANDO' | translate }}</span>
                </div>
              </div>
            </div>
          </form>
        </fieldset>
      </p-panel>
      <div class="grid form-footer-buttons" *ngIf="nivel && nivel.idRiesgosSarlaftniveles">
        <div class="form-group col-12">
          <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button"
                  pButton (click)="regresar(false)"></button>
        </div>
      </div>
    </div>
  </div>
</div>
<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
